import Vue from 'vue';
import Vant, { Locale } from 'vant';
import zhCN from 'vant/lib/locale/lang/zh-CN';
import 'vant/lib/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import http from './api';
import './assets/styles/global.css';

Vue.config.productionTip = false;
Locale.use('zh-CN', zhCN);
Vue.use(Vant);
Vue.prototype.$http = http;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');